/* eslint-disable react-hooks/exhaustive-deps */
import { useAppDispatch, useAppSelector } from 'app/hooks';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { authenticateSettings } from 'components/helper/appConfig';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import LoadingContent from 'components/LoadingContent';
import { Button, Container } from 'react-bootstrap';
import { getCollege, getFuturePlan, getHighSchool } from 'app/highSchoolSlice/highSchoolSlice';
import {
  checkEnableParseJSON,
  formatBoolean,
  formatBooleanToYesNo,
  formatDate,
  formatMonth,
} from 'components/helper/helper';
import { CheckboxContent } from './components/ItemContent';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';

interface Props {}

export const buildContent = (item: any, index: number) => {
  const renderOption = [
    { value: 'IN_CA', label: 'In California' },
    { value: 'OUTSIDE_CA', label: 'Outside California (in the U.S.)' },
    { value: 'OUTSIDE_USA', label: 'Outside the U.S.' },
  ];
  const renderText = item?.where_attend_high_school?.includes('_')
    ? renderOption.find((opt) => opt.value === item?.where_attend_high_school)?.label
    : item?.where_attend_high_school;

  return !item ? null : (
    <div key={index} className="gm-summary-conditional-section">
      <div className="gm-summary-conditional-title">School Information</div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">School name</div>
          <div
            className="gm-summary-field-value"
            style={{
              color: item.high_school_object?.match_all ? '#4d88f0' : 'black',
            }}
          >
            {item?.high_school_name || '-'}
          </div>
        </div>
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">Where do/did you attend high school?</div>
          <div className="gm-summary-field-value">{renderText || '-'}</div>
        </div>
      </div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">
            Specialized curriculum (only select if applicable to you)
          </div>
          <div className="gm-summary-field-value">
            <div className="gm-summary-checkbox-item">
              <div className="gm-summary-text-primary">
                <span
                  style={{
                    marginRight: '12px',
                    fontSize: '18px',
                    color: formatBoolean(item?.is_home_school) ? '#1890ff' : '#d9d9d9',
                    fontWeight: formatBoolean(item?.is_home_school) ? 'bold' : 'normal',
                  }}
                >
                  {formatBoolean(item?.is_home_school) ? '✓' : '○'}
                </span>
                Home School
              </div>
            </div>
            <div className="gm-summary-checkbox-item">
              <div className="gm-summary-text-primary">
                <span
                  style={{
                    marginRight: '12px',
                    fontSize: '18px',
                    color: formatBoolean(item?.is_independant_study) ? '#1890ff' : '#d9d9d9',
                    fontWeight: formatBoolean(item?.is_independant_study) ? 'bold' : 'normal',
                  }}
                >
                  {formatBoolean(item?.is_independant_study) ? '✓' : '○'}
                </span>
                Independent Study
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">Date Range</div>
          <div className="gm-summary-field-value">
            ({formatMonth(item?.start_date)} to {formatMonth(item?.end_date)})
          </div>
        </div>
      </div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">
            What grades did you attend this high school? *
          </div>
          <div className="gm-summary-field-value">
            {(item?.grade ?? []).map((grade: string, i: number) => (
              <div key={i} className="gm-summary-grade-item">
                <div className="row">
                  <div className="col-md-4">
                    <div className="gm-summary-grade-info">
                      {grade} ({item?.academic_year[i]})
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="gm-summary-checkbox-container2" style={{textAlign:'right'}}>
                      <div className="gm-summary-text-primary">
                        <span
                          style={{
                            marginRight: '12px',
                            fontSize: '18px',
                            color: formatBoolean(item?.is_summer_took[i])
                              ? '#1890ff'
                              : '#d9d9d9',
                            fontWeight: formatBoolean(item?.is_summer_took[i])
                              ? 'bold'
                              : 'normal',
                          }}
                        >
                          {formatBoolean(item?.is_summer_took[i]) ? '✓' : '○'}
                        </span>
                        I took summer courses after this grade
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
            
      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">
            Specialized curriculum (if associated with this school)
          </div>
          <div className="gm-summary-field-value">
            <div className="row">
              <CheckboxContent key={`specialized_curriculum_1`} col={12} label={`Career Pathway/Academy`} values={item?.specialized_curriculum_career} />
              <CheckboxContent key={`specialized_curriculum_2`} col={12} label={`International Baccalaureate`} values={item?.specialized_curriculum_international} />
              <CheckboxContent key={`specialized_curriculum_3`} col={12} label={`Magnet`} values={item?.specialized_curriculum_magnet} />
              <CheckboxContent key={`specialized_curriculum_4`} col={12} label={`Other`} values={item?.specialized_curriculum_other} />
            </div>
          </div>
        </div>

        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">What's this school grading scale?</div>
          <div className="gm-summary-field-value">
            <div className="row">
              <CheckboxContent key={`grading_scale_1`} col={12} label={`A B C D F`} values={item?.grading_scale_is_abcdf} />
              <CheckboxContent key={`grading_scale_2`} col={12} label={`0-100(U.S.)`} values={item?.grading_scale_is_0_100} />
              <CheckboxContent key={`grading_scale_3`} col={12} label={`1-7 Int'l Bacc`} values={item?.grading_scale_is_1_7} />
              <CheckboxContent key={`grading_scale_4`} col={12} label={`Other`} values={item?.grading_scale_is_other} />
            </div>
          </div>
        </div>
      </div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">What's its school system?</div>
          <div className="gm-summary-field-value">{item?.classes_schedule || '-'}</div>
        </div>
      </div>
      
      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">
            Does your school have another grading system that has been used while you have attended?
          </div>
          <div className="gm-summary-field-value">{formatBooleanToYesNo(item?.have_other_grading_system) || '-'}</div>
        </div>
      </div>

      {formatBoolean(item?.have_other_grading_system)  && (
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">What is the second school system?</div>
            <div className="gm-summary-field-value">{item?.second_grading_system || '-'}</div>
          </div>
        </div>
      )}

      <div className="gm-summary-conditional-title mt-5">School Type Questions</div>
      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">Is this a boarding school?*</div>
          <div className="gm-summary-field-value">{formatBooleanToYesNo(item?.is_boarding_school)}</div>
        </div>
      </div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">Do you live on campus?</div>
          <div className="gm-summary-field-value">{formatBooleanToYesNo(item?.is_live_on_campus)}</div>
        </div>
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">Did or will you graduate from this school?</div>
          <div className="gm-summary-field-value">
            {formatBooleanToYesNo(item?.is_graduate_from_this_school)}
          </div>
        </div>
      </div>

      {formatBoolean(item?.is_graduate_from_this_school) && (
        <>
          <div className="border my-3 w-100"></div>
          <div className="gm-summary-conditional-title mt-3">Graduation Details</div>

          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Degree, diploma, or certification received or to be received. *</div>
              <div className="gm-summary-field-value">{item?.degree || '-'}</div>
            </div>
          </div>

          {item?.degree === 'Other' && (
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Other</div>
                <div className="gm-summary-field-value">{item?.degreeFreeText}</div>
              </div>
            </div>
          )}
          
          {item?.degree !== 'No degree from this high school' && (
              <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Date received or to be received</div>
                <div className="gm-summary-field-value">
                  {item?.month}/{item?.day}/{`${item?.year}`.replace('- Select -','-')}
                </div>
              </div>
            </div>
          )}
          
        </>
      )}

    </div>
  );
};

export const buildContentCollege = (item: any, index: number) => {
  const buildHeader = (item: any) => {
    const title: any = item?.college_name ?? '';
    const details = [];

    if (item?.college_ceeb) {
      details.push(`CEEB: ${item?.college_ceeb ?? ''}`);
    }

    // Add date range if both fromDate and toDate are available
    if (item?.fromDate && item?.toDate) {
      details.push(
        `${formatDate(item?.fromDate, 'MM/DD/YYYY')} to ${formatDate(item?.toDate, 'MM/DD/YYYY')}`
      );
    }
    // Add only fromDate if toDate is not available
    else if (item?.fromDate) {
      details.push(`${formatDate(item?.fromDate, 'MM/DD/YYYY')}`);
    }

    return details.length > 0 ? `${title} - ${details.join(' - ')}` : title;
  };

  return !item ? null : (
    <div className="gm-summary-conditional-section">
      <div className="gm-summary-conditional-title">College Information</div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">College Name</div>
          <div
            className="gm-summary-field-value"
            style={{
              color: item?.school?.id ? '#4d88f0' : 'black',
            }}
          >
            {buildHeader(item)}
          </div>
        </div>
      </div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          {/* <div className="gm-summary-field-label">Check if you are still attending this college or university</div>
          <div className="gm-summary-field-value">
            {formatBoolean(item?.isStillAttendingThisCollege)}
          </div> */}
          <div className="gm-summary-checkbox-item">
            <div className="gm-summary-text-primary">
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(item?.isStillAttendingThisCollege) ? '#1890ff' : '#d9d9d9',
                  fontWeight: formatBoolean(item?.isStillAttendingThisCollege) ? 'bold' : 'normal',
                }}
              >
                {formatBoolean(item?.isStillAttendingThisCollege) ? '✓' : '○'}
              </span>
              Check if you are still attending this college or university
            </div>
          </div>
        </div>
      </div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">Course Details</div>
          <div className="gm-summary-field-value">
            <div className="gm-summary-checkbox-item">
              {/* <div className="gm-summary-text-primary">Dual enrollment with high school</div> */}
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(item?.college_is_dual_enrollment) ? '#1890ff' : '#d9d9d9',
                  fontWeight: formatBoolean(item?.college_is_dual_enrollment) ? 'bold' : 'normal',
                }}
              >
                {formatBoolean(item?.college_is_dual_enrollment) ? '✓' : '○'}
              </span>
              Dual enrollment with high school
            </div>
            <div className="gm-summary-checkbox-item">
              {/* <div className="gm-summary-text-primary">Credit awarded directly by college</div> */}
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(item?.college_is_credit_awarded) ? '#1890ff' : '#d9d9d9',
                  fontWeight: formatBoolean(item?.college_is_credit_awarded) ? 'bold' : 'normal',
                }}
              >
                {formatBoolean(item?.college_is_credit_awarded) ? '✓' : '○'}
              </span>
              Credit awarded directly by college
            </div>
            <div className="gm-summary-checkbox-item">
              {/* <div className="gm-summary-text-primary">Summer program</div> */}
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(item?.college_is_summer_program) ? '#1890ff' : '#d9d9d9',
                  fontWeight: formatBoolean(item?.college_is_summer_program) ? 'bold' : 'normal',
                }}
              >
                {formatBoolean(item?.college_is_summer_program) ? '✓' : '○'}
              </span>
              Summer program
            </div>
          </div>
        </div>
      </div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">
            Do you expect to earn a degree from this college? *
          </div>
          <div className="gm-summary-field-value">
            {formatBooleanToYesNo(item?.expect_to_earn_degree_from_San_Diego_Mesa)}
          </div>
        </div>
      </div>

      {item?.expect_to_earn_degree_from_San_Diego_Mesa === 'true' && (
        <>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Degree info*</div>
              <div className="gm-summary-field-value">{item?.degree_info || '-'}</div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Degree in progress or will be earned</div>
              <div className="gm-summary-field-value">{item?.degree_earned || '-'}</div>
            </div>
          </div>

          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Details of degree in progress or will be earned*
              </div>
              <div className="gm-summary-field-value">
                {item?.college_info?.detail_degree_earned || '-'}
              </div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">When did you earn that degree?*</div>
              <div className="gm-summary-field-value">
                {`${item?.college_info?.when_you_earn_degree_month} - ${item?.college_info?.when_you_earn_degree_year}` ||
                  '-'}
              </div>
            </div>
          </div>

          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">What was your major?*</div>
              <div className="gm-summary-field-value">{item?.college_info?.your_major || '-'}</div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">What was your minor?</div>
              <div className="gm-summary-field-value">{item?.college_info?.your_minor || '-'}</div>
            </div>
          </div>

          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Check if you were a double major</div>
              <div className="gm-summary-field-value">
                {formatBooleanToYesNo(item?.college_info?.have_double_major)}
              </div>
            </div>
            {item?.college_info?.have_double_major && (
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Select Second Major?</div>
                <div className="gm-summary-field-value">
                  {item?.college_info?.your_second_major || '-'}
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">College's grading system?</div>
          <div className="gm-summary-field-value">
            <div className="gm-summary-checkbox-item">
              {/* <div className="gm-summary-text-primary">A B C D F</div> */}
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(item?.college_grading_system_alphabet)
                    ? '#1890ff'
                    : '#d9d9d9',
                  fontWeight: formatBoolean(item?.college_grading_system_alphabet)
                    ? 'bold'
                    : 'normal',
                }}
              >
                {formatBoolean(item?.college_grading_system_alphabet) ? '✓' : '○'}
              </span>
              A B C D F
            </div>
            <div className="gm-summary-checkbox-item">
              {/* <div className="gm-summary-text-primary">Other</div> */}
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(item?.college_grading_system_other) ? '#1890ff' : '#d9d9d9',
                  fontWeight: formatBoolean(item?.college_grading_system_other) ? 'bold' : 'normal',
                }}
              >
                {formatBoolean(item?.college_grading_system_other) ? '✓' : '○'}
              </span>
              Other
            </div>
          </div>
        </div>
      </div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">Type of term system?*</div>
          <div className="gm-summary-field-value">
            {item?.college_info?.type_of_term_systerm || '-'}
          </div>
        </div>
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">Your tuition status</div>
          <div className="gm-summary-field-value">
            {item?.college_info?.your_tuition_status || '-'}
          </div>
        </div>
      </div>

      <div className="gm-summary-field-grid">
        <div className="gm-summary-field-item">
          <div className="gm-summary-field-label">
            During which grades and terms did you attend this college?
          </div>
            {(item?.grades.length>0) ? (
              <div className="gm-summary-grades-table" style={{ overflowX: 'auto', width: '100%'}}>
              <table className="table table-bordered" style={{ minWidth: 490 }}>
                <thead>
                  <tr>
                    <th>Grade</th>
                    <th>Fall</th>
                    <th>Winter</th>
                    <th>Spring</th>
                    <th>Summer</th>
                  </tr>
                </thead>
                <tbody>
                  {item?.grades.map((_: any, i: number) => (
                    <tr key={i}>
                      <td>{item?.grades[i] || '-'}</td>
                      <td>{item?.grades_fall[i] || '-'}</td>
                      <td>{item?.grades_winter[i] || '-'}</td>
                      <td>{item?.grades_spring[i] || '-'}</td>
                      <td>{item?.grades_summer[i] || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            ) : (
            <div>No data</div>
            )}
        </div>
      </div>
    </div>
  );
};

const EducationSum = (props: Props) => {
  const [loading, setLoading] = React.useState(true);
  const highSchoolStore = useAppSelector((store) => store.highSchool);
  const myHighSchool = {
    ...highSchoolStore.myHighSchool,
    graduating_school_array:
      checkEnableParseJSON(highSchoolStore.myHighSchool?.graduating_school_array) ?? [],
    high_school_array: checkEnableParseJSON(highSchoolStore.myHighSchool?.high_school_array) ?? [],
    high_school_info: checkEnableParseJSON(highSchoolStore.myHighSchool?.high_school_info),
  };

  const myCollege = {
    ...highSchoolStore.myCollege,
    colleges_taken_coursework_array:
      checkEnableParseJSON(highSchoolStore.myCollege?.colleges_taken_coursework_array) ?? [],
  };
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getData = () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      Promise.all([
        dispatch(getHighSchool(studentId)),
        dispatch(getCollege(studentId)),
        dispatch(getFuturePlan(studentId)),
      ]).then(() => {
        setLoading(false);
      });
      return () => setLoading(true);
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getData();
  }, []);

  return loading === true ? (
    <LoadingContent />
  ) : (
    <div>
      <TopProcessBar stepProcess={[]} title="Summary" process={1} icon={<NoteAddOutlinedIcon />} />
      <Container className="main-container">
        <div className="px-2">
          <div className="gm-summary-container">
            <div className="d-flex justify-content-between mb-4">
              <div className="gm-summary-main-title">Education</div>
            </div>

            {/* High School Section */}
            <div className="gm-summary-section">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="gm-summary-section-title">High School</div>
                <Button
                  onClick={() => history.push(routers.highSchool.path)}
                  variant="outline-primary"
                  className="p-2 px-3"
                >
                  Edit
                </Button>
              </div>

              {buildContent(myHighSchool?.high_school_array[0], -1)}

              {myHighSchool && (
                <>
                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">
                        Number of other secondary/high school(s) you have attended
                      </div>
                      <div className="gm-summary-field-value">
                        {myHighSchool?.number_of_other_school_attended || '-'}
                      </div>
                    </div>
                  </div>

                  {myHighSchool?.high_school_array?.length > 1 && (
                    <div className="gm-summary-conditional-section">
                      <div className="gm-summary-conditional-title">
                        Other Secondary/High School(s)
                      </div>
                      <div className="gm-summary-field-content">
                        {myHighSchool?.high_school_array
                          .filter((item: any, index: number) => index !== 0)
                          .map((item: any, index: number) => buildContent(item, index))}
                      </div>
                    </div>
                  )}

                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">
                        Please provide details about why you left each of the above secondary/high
                        schools
                      </div>
                      <div className="gm-summary-field-value">
                        {myHighSchool?.high_school_info?.left_highschool_reason || '-'}
                      </div>
                    </div>
                  </div>

                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">
                        If there's anything else you want us to know about your academic history,
                        you can do so in the space below. But remember, you should use this space
                        only if you want to describe anything that you have not had the opportunity
                        to include elsewhere in this section (for example: a break in attendance,
                        poor grades in a particular course or year, specific information about your
                        school environment or policies that affect your academic record or choices
                        for classes).
                      </div>
                      <div className='gm-summary-field-label'>Why you have missing academic year courses, aka summer courses only, at a specific high school listed above.*</div>
                      <div className="gm-summary-field-value">
                        {myHighSchool?.high_school_info?.academic_history || '-'}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Graduating School Section */}
            <div className="gm-summary-section">
              <div className="gm-summary-section-title">Graduating School</div>

              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Your graduating high school.</div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.graduating_school_array?.graduating_high_school || '-'}
                  </div>
                </div>
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Most recent academic year *</div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.graduating_school_array?.graduating_school_year || '-'}
                  </div>
                </div>
              </div>

              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">GPA Weighting</div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.graduating_school_array?.graduating_school_gpa_type || '-'}
                  </div>
                </div>
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">GPA Scale</div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.graduating_school_array?.graduating_school_gpa_scale || '-'}
                  </div>
                </div>
              </div>

              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Cumulative GPA</div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.graduating_school_array?.graduating_school_cumulative_gpa || '-'}
                  </div>
                </div>
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Class size</div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.graduating_school_array?.graduating_school_class_size || '-'}
                  </div>
                </div>
              </div>

              {myHighSchool?.graduating_school_gpa_scale === 'Other' && (
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">GPA scale other *</div>
                    <div className="gm-summary-field-value">
                      {myHighSchool?.gpa_scale_other || '-'}
                    </div>
                  </div>
                </div>
              )}

              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Rank Report</div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.graduating_school_array?.graduating_school_rank_report || '-'}
                  </div>
                </div>
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Class Rank*</div>
                  <div className="gm-summary-field-value">{myHighSchool?.class_rank || '-'}</div>
                </div>
              </div>

              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    How are the grades for this class reported on your transcript?
                  </div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.rank_weighting || '-'}
                  </div>
                </div>
              </div>
            </div>

            {/* Counselor Information Section */}
            <div className="gm-summary-section">
              <div className="gm-summary-section-title">Counselor Information</div>

              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Counselor's First Name</div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.counselor_first_name || '-'}
                  </div>
                </div>
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Counselor's Last Name</div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.counselor_last_name || '-'}
                  </div>
                </div>
              </div>

              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Counselor's Email</div>
                  <div className="gm-summary-field-value">
                    {myHighSchool?.counselor_email || '-'}
                  </div>
                </div>
              </div>
            </div>

            {/* Colleges & Universities Section */}
            <div className="gm-summary-section">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="gm-summary-section-title">Colleges & Universities</div>
                <Button
                  onClick={() => history.push(routers.collegeAndUniversity.path)}
                  variant="outline-primary"
                  className="p-2 px-3"
                >
                  Edit
                </Button>
              </div>

              {myCollege && (
                <>
                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">
                        Have you taken college courses or earned college credit? *
                      </div>
                      <div className="gm-summary-field-value">
                        {formatBoolean(myCollege?.is_taken_college_courses)}
                      </div>
                    </div>
                  </div>

                  {myCollege?.is_taken_college_courses === true && (
                    <>
                      <div className="gm-summary-conditional-section">
                        <div className="gm-summary-conditional-title">
                          College Courses or earned College Credit
                        </div>

                        <div className="gm-summary-field-grid">
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">
                              Are you currently taking courses in college? *
                            </div>
                            <div className="gm-summary-field-value">
                              {formatBoolean(myCollege?.is_currently_taking_courses_in_college)}
                            </div>
                          </div>
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">
                              How many college credits have you earned to date? *
                            </div>
                            <div className="gm-summary-field-value">
                              {myCollege?.number_of_college_credits_have_earned || '-'}
                            </div>
                          </div>
                        </div>

                        <div className="gm-summary-field-grid">
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">
                              How many credits were earned after high school? *
                            </div>
                            <div className="gm-summary-field-value">
                              {myCollege?.number_of_credits_earned_after_school || '-'}
                            </div>
                          </div>
                          <div className="gm-summary-field-item">
                            <div className="gm-summary-field-label">
                              Indicate the number of colleges of universities you've taken a course
                              at or received credit from
                            </div>
                            <div className="gm-summary-field-value">
                              {myCollege?.number_of_colleges_taken_coursework || '-'}
                            </div>
                          </div>
                        </div>

                        <div className="gm-summary-field-content">
                          {myCollege?.colleges_taken_coursework_array.map(
                            (item: any, index: number) => buildContentCollege(item, index)
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>

            {/* Future Plans Section */}
            <div className="gm-summary-section">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="gm-summary-section-title">Future Plans</div>
                <Button
                  onClick={() => history.push(routers.futurePlan.path)}
                  variant="outline-primary"
                  className="p-2 px-3"
                >
                  Edit
                </Button>
              </div>

              {highSchoolStore.myFuturePlan && (
                <>
                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">Career Interest</div>
                      <div className="gm-summary-field-value">
                        {highSchoolStore.myFuturePlan.career_interest || '-'}
                      </div>
                    </div>
                    {highSchoolStore.myFuturePlan?.career_interest === 'Other' && (
                      <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">Specify other organization</div>
                        <div className="gm-summary-field-value">
                          {highSchoolStore.myFuturePlan?.other_career_interest || '-'}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">
                        Highest Degree you intend to earn
                      </div>
                      <div className="gm-summary-field-value">
                        {highSchoolStore.myFuturePlan.highest_degree_intend_to_earn || '-'}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="m-3 d-flex justify-content-end border-top pt-3">
              <div className="col col-md-3">
                <Button
                  variant="primary"
                  onClick={() => history.push(routers.testSum.path)}
                  className="p-2 px-5 w-100"
                >
                  Continue
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default EducationSum;
